import type { FilterableProduct, StrengthLevel } from "../config";
import { isStrengthLevel } from "../config";

export const getStrengthLevelMap = (products: FilterableProduct[]): Record<number, StrengthLevel> => {
  const map: Record<number, StrengthLevel> = {};

  products.forEach((product) => {
    const details = product.productStrengthDetails;
    if (!details || !isStrengthLevel(details.level)) return;

    map[details.rating] = details.level;
  });

  return map;
};
